import { ACCIONES_CRUD } from '../utils/constantes';

export default {
  props: {
    nombreRecurso: {
      type: String,
      default: 'Ítem',
    },
  },
  computed: {
    titulo() {
      const nombreRecurso = this.nombreRecurso.toUpperCase();

      return this.form?.id ? `EDITAR ${nombreRecurso}` : `REGISTRAR ${nombreRecurso}`;
    },
  },
  data() {
    return {
      visible: false,
      form: this.generarObjetoFormRegistrar(),
      errores: [],
      enviando: false,
      accionesCrud: ACCIONES_CRUD,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      alert('Sobrescribe "generarObjetoFormRegistrar" en el componente');

      return {};
    },
    generarObjetoFormEditar() {
      alert('Sobrescribe "generarObjetoFormEditar" en el componente');

      return {};
    },
    abrirMixin(accion, data = null) {
      if (accion == this.accionesCrud.REGISTRAR) {
        this.form = this.generarObjetoFormRegistrar();
      }

      if (accion == this.accionesCrud.EDITAR) {
        this.form = this.generarObjetoFormEditar(data);
      }

      this.errores = [];
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    async registrar() {
      alert('Sobre escribir "registrar" en el componente');
    },
    async editar() {
      alert('Sobre escribir "editar" en el componente');
    },
    validar(fnRegistrar, fnEditar) {
      if (!this.enviando) {
        this.enviando = true;

        if (this.form?.id) {
          fnEditar();
        } else {
          fnRegistrar();
        }
      }
    },
  },
};
